import PropTypes from 'prop-types';
const responsivePropType = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
export default responsivePropType;


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/responsivePropType.js
// module id = 186
// module chunks = 22